import React, { useState, useReducer, useEffect, useContext } from 'react'
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { Button, } from '@chakra-ui/react';

import { app } from '../services/firebase/config';
import { loginReducer } from '../reducers/loginReducer';
import SignInForm from '../components/SingInForm';
import { loginInit } from '../helpers/loginInit';
import { LoginContext } from '../context/LoginContext';
import { useForm } from '../hooks/useForm';

const auth = getAuth(app);

export const Auth = () => {

    const { user, setUser } = useContext(LoginContext);
    const [showForm, setShowForm] = useState("login")
    const [loginState, dispatch] = useReducer(loginReducer, null, loginInit);
    const [thereIsAnerror, setThereIsAnError] = useState("")

    const [formValues, handleInputChange, reset] = useForm({
        email: "",
        password: ""
    });

    const { email, password } = formValues;


    const handleRegister = (e) => {
        e.preventDefault();
        createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                const user = userCredential.user;
                dispatch({
                    type: "login",
                    payload: user
                });
                setUser(user)
                localStorage.setItem("user", JSON.stringify(user))
            })
            .catch((error) => {
                console.log(error.message)
                setThereIsAnError(error.message)
            });

        reset()
    };

    const handleLogin = (e) => {
        e.preventDefault();
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                const user = userCredential.user;
                dispatch({
                    type: "login",
                    payload: user
                });
                setUser(user);
                localStorage.setItem("user", JSON.stringify(user))
            })
            .catch((error) => {
                setThereIsAnError(error.message)
            });

        reset()
    };

    const handleShow = () => {
        if (showForm === "login") {
            setShowForm("register")
        } else {
            setShowForm("login")
        }
    }

    return (
        <>
            <Button onClick={handleShow} position="absolute" top="2" right="4" colorScheme='teal' variant='outline'>
                {showForm === "login" ? "Login" : "Register"}
            </Button>
            {
                showForm === "login" &&
                < SignInForm
                    handleSubmit={handleRegister}
                    handleInputChange={handleInputChange}
                    email={email}
                    password={password}
                    thereIsAnerror={thereIsAnerror}
                    formName="Register"
                />
            }

            {
                showForm === "register" &&
                < SignInForm
                    handleSubmit={handleLogin}
                    handleInputChange={handleInputChange}
                    email={email}
                    password={password}
                    thereIsAnerror={thereIsAnerror}
                    formName="Login"
                />
            }
        </>
    )
}
